var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvaluationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 11.2797C5.8 11.2797 7 12.8797 9 12.8797C11 12.8797 12.2 11.2797 12.2 11.2797M13 7.47169C12.684 7.85969 12.252 8.07969 11.8 8.07969C11.348 8.07969 10.928 7.85969 10.6 7.47169M7.4 7.47169C7.084 7.85969 6.652 8.07969 6.2 8.07969C5.748 8.07969 5.328 7.85969 5 7.47169M17 9.67969C17 14.098 13.4183 17.6797 9 17.6797C4.58172 17.6797 1 14.098 1 9.67969C1 5.26141 4.58172 1.67969 9 1.67969C13.4183 1.67969 17 5.26141 17 9.67969Z",
    stroke: "#EB5B1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationIcon);
export default __webpack_public_path__ + "static/media/evaluation-icon.c1fb37a198c3e25c520b35edded2d49f.svg";
export { ForwardRef as ReactComponent };